// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__1xpA3","messages":"Chat_messages__3kVNl","dateDivider":"Chat_dateDivider__2SWSM"};